import React from 'react';
import { Div } from '@pinpoint/design-kit';

function Wrapper({ children }) {
  return (
    <Div w="100%" h="100%" overflow="hidden">
      {children}
    </Div>
  );
}

export default Wrapper;
